import { createContext } from "react";

const UsuarioContext = createContext();

export default UsuarioContext;
